import {
  Box,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Event } from '@material-ui/icons';
import { useLoanStore } from '@roc/feature-loans-shared';
import { Paper } from '@roc/ui';
import { format } from 'date-fns';
import { CSSProperties, useMemo } from 'react';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '16px',
  },
  label: {
    fontWeight: 400,
    fontSize: '16px',
    letterSpacing: '-0.4px',
    lineHeight: '100%',
    color: '#989898',
    marginBottom: '16px',
  },
  value: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '157%',
    letterSpacing: '0.1px',
  }
}));

const LoanKeyDates = ({
  containerStyle,
  paperStyle,
} : {
  containerStyle?: CSSProperties,
  paperStyle?: CSSProperties,
}) => {
  const { loanStore } = useLoanStore();
  const { loanDetails } = loanStore;
  const classes = useStyles();
  const maturityDate = useMemo(() => loanDetails?.maturityDate ? format(new Date(loanDetails?.maturityDate), 'MMMM d, yyyy') : '', [loanDetails]);
  // TODO: this field is not being returned by the API
  const extendedMaturityDate = useMemo(() => loanDetails?.extendedMaturityDate ? format(new Date(loanDetails?.extendedMaturityDate), 'MMMM d, yyyy') : '', [loanDetails]);

  return (
    <Grid item style={containerStyle}>
      <Paper title="Key Dates" style={paperStyle}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={12}>
            <Grid container direction="row" spacing={2} className={classes.container}>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className={classes.label}>
                  Maturity Date:
                </Typography>
                <Typography variant="body2" className={classes.value}>
                  {maturityDate}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className={classes.label}>
                  Extended Maturity Date:
                </Typography>
                <Typography variant="body2" className={classes.value}>
                  {extendedMaturityDate}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export const LoanKeyDatesNew = () => {
  const { loanStore } = useLoanStore();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Paper style={{
          background: 'linear-gradient(135deg, rgba(118, 176, 241, 0.2), rgba(32, 101, 209, 0.2)) rgb(255, 255, 255)',
          boxShadow: 'none',
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}>
          <Box p={4} width={'100%'} textAlign={'center'}>
            <Box mb={.5}>
              <Event />
            </Box>
            <Typography variant='h4' gutterBottom>
              {loanStore?.loanDetails?.submissionDate ?? '-'}
            </Typography>
            <Typography variant='body2'>
              Loan Submission Date
            </Typography>
          </Box>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper style={{
          background: 'linear-gradient(135deg, rgba(97, 243, 243, 0.2), rgba(0, 184, 217, 0.2)) rgb(255, 255, 255)',
          boxShadow: 'none',
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}>
          <Box p={4} width={'100%'} textAlign={'center'}>
            <Box mb={.5}>
              <Event />
            </Box>
            <Typography variant='h4' gutterBottom>
              {loanStore?.loanDetails?.closingDate ?? '-'}
            </Typography>
            <Typography variant='body2'>
              Loan Closing Date
            </Typography>
          </Box>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper style={{
          background: 'linear-gradient(135deg, rgba(255, 214, 102, 0.2), rgba(255, 171, 0, 0.2)) rgb(255, 255, 255)',
          boxShadow: 'none',
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}>
          <Box p={4} width={'100%'} textAlign={'center'}>
            <Box mb={.5}>
              <Event />
            </Box>
            <Typography variant='h4' gutterBottom>
              {loanStore?.loanDetails?.extendedMaturityDate ?? '-'}
            </Typography>
            <Typography variant='body2'>
              Loan Maturity Date
            </Typography>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default LoanKeyDates;
